(ns app.front.view.workspace.header
  (:require [app.domain.address.model :as address-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.group.model :as group-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.licence.model :as licence-model]
            [app.domain.party.model :as party-model]
            [app.domain.property.model :as property-model]
            [app.domain.user.authority :as authority]
            [app.domain.util :as du]
            [app.domain.verdict.model :as verdict-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.municipality :as municipality]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.editable-attr :as ui-edit-attr]
            [app.front.ui.email-toggle :as ui-email-toggle]
            [app.front.ui.icon-button :as ui-ib]
            [app.front.ui.inline-editable :as inline-editable]
            [app.front.ui.messages-panel :as messages-panel]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.ui.separator :as ui-sep]
            [app.front.ui.status :as ui-status]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.application-wizard.navigation :as application-wizard]
            [app.front.view.application.phase-subs :as app-phase-subs]
            [app.front.view.application.work-type-target :as work-select]
            [app.front.view.common.data-grid :as dg]
            [app.front.view.common.header :as header-common]
            [app.front.view.create-application.create-v2 :as create-v2]
            [app.front.view.permit.download :as permit-download]
            [app.front.view.property.attribute :as property-attribute]
            [app.front.view.property.units-editor :as units-editor]
            [app.front.view.property.util :as property-util]
            [app.front.view.workspace.additional-properties :as additional-properties]
            [app.front.view.workspace.address :as workspace-address]
            [app.front.view.workspace.location :as workspace-location]
            [app.front.view.workspace.map :as workspace-map]
            [app.front.view.workspace.property-subs :as property-subs]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-sub ::permit-exists?
  :<- [::entities/context]
  (fn [ctx [_ application]]
    (not (nil? (entities/find-entities ctx {:entity/type   :entity.type/verdict
                                            :entity/parent (:db/id application)})))))
(rf/reg-sub ::editing? :-> ::editing?)

(rf/reg-event-db ::set-editing
  (fn [db [_ editing-toggle]]
    (assoc db ::editing? editing-toggle)))

(rf/reg-sub ::full-workspace-info-visible?
  #(::header-common/full-workspace-info-visible? % (header-common/full-header-info-by-default?)))

(rf/reg-event-db ::toggle-full-workspace-info-visibility
  (fn [db]
    (let [db-value  (::header-common/full-workspace-info-visible? db)
          ls-value  (header-common/full-header-info-by-default?)
          new-value (not (if (nil? db-value) ls-value db-value))]
      (header-common/set-full-header-info-default new-value)
      (-> db
          (assoc ::header-common/full-workspace-info-visible? new-value)
          (dissoc ::header-common/map-view-id)))))

;;
;; Email subscription
;;

(rf/reg-event-fx ::email-subscription
  (fn [_ [_ workspace value]]
    {:comm/command {:command    :party/set-notifications-subscription
                    :data       {:set-value-to (not value)
                                 :workspace/id (-> workspace :workspace/id)}
                    :on-success [::entities/apply-changes]}}))

;;
;; Edit property data
;;

(rf/reg-event-db ::set-address-in-editor
  (fn [db [_ address-entity]]
    (assoc db ::address-in-editor address-entity)))

(rf/reg-sub ::address-in-editor :-> ::address-in-editor)

(rf/reg-event-fx ::save-modified-address
  (fn [{:keys [db]} [_ workspace-address-id application-id]]
    (let [address (->> db
                       ::address-in-editor
                       (p/remove-vals #(or (and (string? %) (str/blank? %))
                                           (nil? %))))]
      {:dispatch-n [[:app.front.process/signal
                     application-id
                     [:process.signal/edit-address {:address address}]
                     {:notify {:success :workspace/address-saved}}]
                    [::entities/update-entity workspace-address-id address]]
       :db         (dissoc db ::address-in-editor)})))

(rf/reg-event-fx ::save-modified-id-or-legal
  (fn [{:keys [db]} [_ target-id save-signal]]
    (let [attrs       (second save-signal)
          property-id (:property-id attrs)
          new-val-map (dissoc attrs :property-id)]
      {:dispatch-n [[:app.front.process/signal
                     target-id
                     save-signal
                     {:notify {:success :workspace/property-attribute-saved}}]
                    [::entities/update-entity property-id new-val-map]]
       :db         (if (contains? new-val-map :property/id)
                     (dissoc db ::editing-property-id?)
                     (dissoc db ::editing-property-legal?))})))

(rf/reg-event-db ::set-property-id-edit
  (fn [db [_ editing?]]
    (assoc db ::editing-property-id? editing?)))

(rf/reg-event-db ::set-property-legal-edit
  (fn [db [_ editing?]]
    (assoc db ::editing-property-legal? editing?)))

(rf/reg-sub ::editing-property-id?
  :-> ::editing-property-id?)

(rf/reg-sub ::editing-property-legal?
  :-> ::editing-property-legal?)

(rf/reg-event-db ::set-id-in-property-editor
  (fn [db [_ id]]
    (assoc db ::id-in-property-editor id)))

(rf/reg-event-db ::set-legal-in-property-editor
  (fn [db [_ legal]]
    (assoc db ::legal-in-property-editor legal)))

(rf/reg-sub ::id-in-property-editor
  :-> ::id-in-property-editor)

(rf/reg-sub ::legal-in-property-editor
  :-> ::legal-in-property-editor)

(rf/reg-sub ::adding-new-unit?
  :-> ::adding-new-unit?)

(rf/reg-sub ::municipality-name
  :<- [::ws-subs/workspace]
  :<- [:language]
  (fn [[workspace lang] _]
    (workspace-model/municipality-name lang workspace)))

(rf/reg-sub ::upper-tier-municipality-name
  :<- [::ws-subs/authority-group]
  (fn [authority-group _]
    (when (group-model/has-multiple-municipalities? authority-group)
      (-> authority-group ; Don't use this directly, name contains e.g. "Building Department"
          :entity/parent ; "municipality group", e.g. "Red River Planning District"
          :group/name))))

(rf/reg-sub ::show-address-header?
  :<- [::ws-subs/workspace]
  (fn [{:workspace/keys [permit-type] :as workspace} _]
    (or (-> workspace workspace-model/full-address boolean)
        ;; Show missing address text and associated update property button even on licensing if property is missing due to data import etc but configuration is set to have a property.
        (and (= permit-type (or :permit-type/L :permit-type/LS))
             (not (config-model/resolve-boolean :group.config/no-workspace-location workspace)))
        (not (contains? ptc-model/permit-types-without-mandatory-location permit-type)))))

(rf/reg-sub ::party-for-notifications
  (fn [[_ phase-id]]
    [(rf/subscribe [:session/user])
     (rf/subscribe [::entities/entity phase-id])])
  (fn [[user phase-entity] _]
    (let [user-parties (party-model/parties-for-user user phase-entity)]
      ;; if user has business parties and user parties, hide the toggle, too difficult to
      ;; see the affected parties in this situation.
      (util/only user-parties))))

(rf/reg-sub ::map-visible?
  (fn [[_ workspace-db-id]]
    [(rf/subscribe [::ws-subs/loading?])
     (rf/subscribe [::header-common/map-visible? workspace-db-id])
     (rf/subscribe [::property-subs/property-widget-visible?])
     (rf/subscribe [::workspace-location/open?])])
  (fn [[loading? map-visible? property-widget-visible? edit-ws-location-visible?] _]
    (and (not loading?)
         (or map-visible?
             property-widget-visible?
             edit-ws-location-visible?))))

(rf/reg-sub ::hide-workspace-location?
  :<- [::property-subs/change-property-visible?]
  :<- [::property-subs/add-visible?]
  (fn [[change-property-visible? add-visible?] _]
    (or change-property-visible?
        add-visible?)))

(rf/reg-sub ::workspace-geometry-as-features
  :<- [::hide-workspace-location?]
  :<- [::workspace-location/open?]
  (fn [[hide-workspace-location? edit-ws-location-visible?] [_ workspace-geometry]]
    (when-not hide-workspace-location?
      (->> workspace-geometry
           :geometries
           (map-indexed (fn [idx geometry]
                          (property-model/geojson-feature geometry
                                                          (str idx)
                                                          {:selectable edit-ws-location-visible?})))
           property-model/geojson-feature-collection))))

(defn- property-view-changed-effects [property-event]
  {:fx [[:dispatch [::workspace-location/clear-state]]
        [:dispatch [property-event]]]})

(rf/reg-event-fx ::cancel-location-editing
  (fn [_ _]
    (property-view-changed-effects ::property-subs/cancel-add)))

(rf/reg-event-fx ::set-change-property-visible
  (fn [_ _]
    (property-view-changed-effects ::property-subs/set-change-property-visible)))

(rf/reg-event-fx ::set-add-properties-visible
  (fn [_ _]
    (property-view-changed-effects ::property-subs/set-add-visible)))

(rf/reg-event-fx ::set-edit-workspace-location-visible
  (fn [_ _]
    {:fx [[:dispatch [::property-subs/clear-state]]
          [:dispatch [::workspace-location/open]]]}))

(rf/reg-event-fx ::close-map
  (fn [_ _]
    {:fx [[:dispatch [::property-subs/clear-state]]
          [:dispatch [::workspace-location/clear-state]]
          [:dispatch [::workspace-map/set-map-extended false]]]}))

(defn render-editable-attr [title value tr edit-allowed? fsm-target change-signal-fn link]
  [ui-edit-attr/editable-attr
   (merge {:header-element [dg/header-label title]
           :value          value
           :tr             tr
           :on-change      (when edit-allowed?
                             #(>evt [::process/signal
                                     fsm-target
                                     (change-signal-fn %)]))}
          (when link
            {:text-container :a
             :opts           {:href  link
                              :class "bx--link"}}))])

(defn render-inline-editable-attr [title attr value tr edit-allowed? link fsm-target change-signal-fn]
  (r/with-let [*edit-btn-ref (r/atom nil)]
    (let [editing (<sub [::editing?])]
      [:div.flex.flex-col.items-start.pt-1
       [:div.w-full.flex.items-start
        (if link
          [:a.flex-1.break-words {:href link :class "bx--link"} value]
          [:span.flex-1.break-words value])]
       (when edit-allowed?
         [:div.mt-2.ml-auto
          [ui/button
           {:kind             :ghost
            :icon             i/pen
            :icon-position    :right
            :class-name       "bottom-0 max-h-4"
            :size             :small
            :icon-description (tr [:edit])
            :on-click         #(>evt [::set-editing attr])
            :ref              #(reset! *edit-btn-ref %)}
           (tr [:edit])]])
       (when (= editing attr)
         [inline-editable/popup-wrapper
          {:tr      tr
           :class   "top-0"
           :title   title
           :*anchor *edit-btn-ref}
          [inline-editable/text-field-confirm
           {:tr         tr
            :input-opts {:class         ""
                         :auto-focus    true
                         :default-value value}
            :on-confirm (fn [new-value]
                          (>evt [::set-editing nil])
                          (>evt [::process/signal
                                 fsm-target
                                 (change-signal-fn new-value)]))
            :on-cancel  #(>evt [::set-editing nil])}]])])))

(defn application-email-notifications
  [{:keys [tr target-id workspace]}]
  (let [party                  (<sub [::party-for-notifications target-id])
        notifications-enabled? (not (:party/notifications-disabled party))]
    (when party
      [ui-email-toggle/email-toggle
       (util/mmap {:on-toggle (fn [value] (>evt [::email-subscription workspace value]))}
                  tr notifications-enabled?)])))

(defn application-messaging-row [{:keys [tr loading? workspace]}]
  (if loading?
    [:div.mb-2.mr-16
     (cc/button-skeleton)]
    [:div.mb-2.mr-16.flex.items-center
     (cc/icon {:icon        i/conversation
               :description (tr [:conversation/show-messages])
               :fill        "#0F3FD2"
               :height      "1em"
               :aria-hidden true})
     (cc/link
       {:href       "#"
        :on-click   #(do
                       (.stopPropagation %)
                       (.preventDefault %)
                       (>evt [::messages-panel/toggle-open (:workspace/id workspace)]))
        :class-name "ml-2"}
       (tr [:conversation/show-messages]))]))

(defn ws-info [label content & [always-visible? critical-notice?]]
  (let [full-ws-info-visible? (<sub [::full-workspace-info-visible?])]
    (when (and content (or always-visible? full-ws-info-visible?))
      [dg/grid-item {:label label
                     :class (concat ["min-h-20"]
                                    (when critical-notice?
                                      [(ui-status/status->border-color-class :attention)
                                       "border-l-6"
                                       "border-solid"]))}
       content])))

(defn integration-sync-times [{:keys [tr workspace authority? attr label]}]
  (when-let [sync-tss (and authority? (attr workspace))]
    (let [format-date-time (<sub [::date-util/date-time-fn])]
      [ws-info
       (or label (tr [attr]))
       [:<>
        [:div (str (tr [:created]) " " (-> sync-tss sort first format-date-time))]
        (when (du/at-least-two? sync-tss)
          [:div.mt-1 (str (tr [:updated]) " " (-> sync-tss sort last format-date-time))])]])))

(defn created-at [{:keys [workspace tr]}]
  (when (-> workspace :workspace/permit-type (= :permit-type/CE))
    [ws-info
     (tr [:entity/created])
     [:div ((<sub [::date-util/date-time-fn]) (:entity/created workspace))]
     true]))

(def date-picker-width
  "minimum possible width available when tiniest possible large-sized screen (smaller sizes have less columns)"
  "150px")

(defn timestamp-item [{:keys [by-attr
                              ts-attr
                              fsm-target
                              tr
                              signal
                              date-label
                              time-label
                              success
                              error
                              always-visible?]}]
  (r/with-let [*value (r/atom nil)]
    (let [timestamp       (-> fsm-target ts-attr)
          editing?        (some? @*value)
          edit-permitted? (and signal (<sub [::process/signal-permitted? fsm-target [signal]]))]
      (when timestamp
        [ws-info
         (tr [ts-attr])
         [:div
          (if editing?
            [create-v2/submit-time-picker-impl (util/mmap {:submit-date (or @*value timestamp)
                                                           :on-change   #(reset! *value %)
                                                           :class       "flex-wrap"
                                                           :width       date-picker-width
                                                           :error       error}
                                                          tr date-label time-label)]
            [:div ((<sub [::date-util/date-time-fn]) timestamp)
             (when-let [done-by (and by-attr (-> fsm-target by-attr))]
               [:<>
                [:br]
                (tr [:by] [(user-model/full-name done-by)])])])
          (when edit-permitted?
            [ui-edit-attr/edit-buttons
             (util/mmap {:value     timestamp
                         :on-change (when (or (nil? @*value) ;; if we don't have it with nil value, the buttons never appear
                                              (create-v2/manual-submit-date-valid? @*value))
                                      #(>evt [::process/signal
                                              (:db/id fsm-target)
                                              [signal {:date %}]
                                              {:notify {:success success}}]))}
                        tr *value)])]
         always-visible?]))))

(defn submitted-at [{:keys [fsm-target tr always-visible?]}]
  [:<>
   (let [pre-con? (eu/is-type? :entity.type/pre-consultation fsm-target)]
     [timestamp-item (merge (util/mmap {:ts-attr (if pre-con? :pre-consultation/submitted :application/submitted)
                                        :signal  :process.signal/set-submitted-date
                                        :success :application/submit-date-changed}
                                       tr fsm-target always-visible?)
                            (when pre-con?
                              {:date-label :pre-consultation/submit-date
                               :time-label :pre-consultation/submit-time
                               :error      :error/request-date-future}))])])

(defn completed-at [{:keys [workspace application tr]}]
  (let [authority?     (-> workspace :granted-permissions :permission.application/review)
        payment-state? (-> application :domain/state (= :state.application/pre-complete-payment))]
    (when (and (= (:workspace/permit-type workspace) :permit-type/P)
               (or authority? (not payment-state?)))
      [timestamp-item (util/mmap {:by-attr         :application/completed-by
                                  :ts-attr         :application/completed
                                  :signal          :process.signal/set-completed-date
                                  :fsm-target      application
                                  :always-visible? false
                                  :date-label      :application/complete-date
                                  :time-label      :application/complete-time
                                  :success         :application/complete-date-changed
                                  :error           :error/complete-date-future}
                                 tr)])))

(defn decision-made-at [{:keys [fsm-target tr]}]
  (when (<sub [::ff/enabled? :feature-flag.id/add-planning-dates-to-import])
    [timestamp-item (util/mmap {:ts-attr :application/decision-made}
                               tr fsm-target)]))

(defn work-started-at [{:keys [fsm-target tr]}]
  [timestamp-item (util/mmap {:ts-attr :execution/work-started-ts}
                             tr fsm-target)])

(defn work-finished-at [{:keys [fsm-target tr]}]
  [timestamp-item (util/mmap {:ts-attr :execution/finished-ts}
                             tr fsm-target)])

(defn pre-con-finished-at [{:keys [fsm-target tr]}]
  [timestamp-item (util/mmap {:ts-attr :pre-consultation/finished-ts}
                             tr fsm-target)])

(defn pre-con-expires-at [{{workspace :entity/parent :as phase} :fsm-target :keys [tr]}]
  ;; expiration date is a date value only, so cannot use common timestamp-item
  (r/with-let [*value (r/atom nil)]
    (let [timestamp       (:workspace/pre-consultation-expires-on workspace)
          edit-permitted? (<sub [::process/signal-permitted?
                                 phase
                                 [:process.signal/override-pre-consultation-expiration-time]])
          editing?        (some? @*value)]
      (when (or (and (some? timestamp)
                     ;; if expiration no longer applicable, just hide the timestamp
                     (not (:workspace/pre-consultation-expiration-passed? workspace)))
                edit-permitted?)
        [:<>
         [ws-info
          (tr [:workspace/pre-consultation-expires-on])
          [:div
           (if editing?
             [:div.flex.flex-wrap
              [ui/date-picker {:required?  true
                               :class-name "md:mr-2"
                               :width      date-picker-width
                               :min-date   (js/Date.)
                               :callback   #(when (some? %)
                                              (reset! *value %))
                               :value      (or @*value timestamp)}]
              (when timestamp
                [ui/modal-confirmation-button
                 {:id                  "clear-pre-con-expiration"
                  :tr                  tr
                  :on-yes-click        (fn [_]
                                         (reset! *value nil)
                                         (>evt [::process/signal
                                                phase
                                                [:process.signal/remove-pre-consultation-expiration-time]]))
                  :trigger-button-opts {:kind :tertiary
                                        :size :small
                                        :icon i/remove}
                  :trigger-button-text (tr [:remove])}
                 (tr [:pre-consultation/remove-expires-confirm])])]
             [:div.flex
              (cond
                (<sub [::process/signal-processing?
                       :process.signal/remove-pre-consultation-expiration-time
                       :process.signal/override-pre-consultation-expiration-time])
                (cc/loading-spinner {:small true :with-overlay false})
                timestamp
                [:span {:data-cy "precon-exp-timestamp"} ((<sub [::date-util/date-fn]) timestamp)]
                :else
                [:span.italic {:data-cy "no-timestamp"} (tr [:pre-consultation/does-not-expire])])])
           (when edit-permitted?
             [ui-edit-attr/edit-buttons
              (util/mmap {:value     timestamp
                          :on-change #(>evt [::process/signal
                                             phase
                                             [:process.signal/override-pre-consultation-expiration-time {:date %}]
                                             {:notify {:success :pre-consultation/expiration-time-set-success}}])}
                         tr *value)])]]]))))

(def field-css-classes
  {:address/street-number    ["w-24 mr-2"
                              "w-10 mr-2"]
   :address/street-name      ["w-48 mr-2"]
   :address/street-type      ["w-32 mr-2"]
   :address/street-direction ["w-20 mr-2"]
   :address/unit-designator  ["w-32 mr-2"
                              "w-24"]})

(defn address-save-buttons [{:keys [tr save-disabled? target-id workspace-address-id]}]
  [:div
   [ui/button
    {:kind             :ghost
     :icon             i/remove
     :icon-position    :right
     :icon-description (tr [:cancel])
     :class-name       "only-icon-button"
     :on-click         #(>evt [::set-address-in-editor nil])}
    ""]
   [ui/button
    {:kind             :ghost
     :icon             i/check
     :icon-position    :right
     :icon-description (tr [:save])
     :class-name       "only-icon-button"
     :disabled         save-disabled?
     :on-click         #(>evt [::save-modified-address workspace-address-id target-id])}
    ""]])

(defn address-editor [tr workspace target-id]
  (let [address (<sub [::address-in-editor])]
    [:div.flex.flex-1.w-full.flex-wrap.items-end
     [workspace-address/address-input-fields
      (util/mmap {:subdivision  (-> workspace workspace-model/single-property :property/municipality :municipality/subdivision)
                  :set-addr-evt ::set-address-in-editor}
                 tr field-css-classes address)]
     [address-save-buttons
      (util/mmap {:save-disabled?       (or (nil? address)
                                            (= address
                                               (select-keys (:workspace/structural-address workspace) address-model/address-keys)))
                  :target-id            target-id
                  :workspace-address-id (-> workspace :workspace/structural-address :db/id)}
                 tr)]]))

(defn editable-attr [{:keys [data-cy title workspace attr change-signal-fn target-id
                             text-container opts always-visible? tr confirm-content]}]
  [ws-info
   nil
   [:div.h-full {:data-cy data-cy}
    [ui-edit-attr/editable-attr
     (p/assoc-if
       {:header-element [dg/header-label title]
        :loading?       (<sub [::ws-subs/loading?])
        :value          (get workspace attr)
        :on-change      (when (<sub [::process/signal-permitted? target-id (change-signal-fn nil)])
                          #(>evt [::process/signal
                                  target-id
                                  (change-signal-fn %)]))}
       :text-container text-container
       :opts opts
       :confirm-content confirm-content
       :tr tr)]]
   always-visible?])

(defn editable-property-attr [{:keys [title property attr change-signal-fn fsm-target missing-warning link always-visible? read-only? tr]}]
  (let [value         (get property attr)
        edit-allowed? (and (not read-only?)
                           (<sub [::process/signal-permitted?
                                  fsm-target
                                  (change-signal-fn nil)]))]
    [ws-info
     nil
     [:div.flex.flex-col.h-full
      (if (ff/enabled? :feature-flag.id/replace-editable-attr)
        [:<>
         [dg/header-label title]
         [render-inline-editable-attr title attr value tr edit-allowed? link fsm-target change-signal-fn]]
        [render-editable-attr title value tr edit-allowed? fsm-target change-signal-fn link])
      (when (and missing-warning edit-allowed? (str/blank? value))
        [:div.flex.mb-2.mt-1
         (cc/icon {:icon        i/circle-attention
                   :description missing-warning
                   :fill        "#f71735"
                   :class-name  "mr-2 w-6 flex-shrink-0"})
         [:div.leading-tight.flex-shrink missing-warning]])
      always-visible?]]))

;; Edit assignee

(rf/reg-event-fx ::fetch-authority-users
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :group/authority-users
                    :method     :get
                    :data       {:workspace-id workspace-id}
                    :on-success [::authority-users-fetch-success workspace-id]}}))

(rf/reg-event-fx ::authority-users-fetch-success
  (fn [{:keys [db]} [_ workspace-id status data]]
    (let [new-db (assoc-in db [::authority-users workspace-id] (keys data))]
      {:db       new-db
       :dispatch [::entities/merge-entity-db status data]})))

(rf/reg-sub ::auth-users
  :-> ::authority-users)

(rf/reg-sub ::auth-users-sorted
  :<- [::auth-users]
  :<- [::ws-subs/workspace-id]
  :<- [:session/user]
  :<- [::entities/entity-db]
  :<- [::entities/components]
  :<- [::entities/schema]
  (fn [[auth-users ws-id current-user entity-db components schema] _]
    (let [user-ids (get auth-users ws-id)]
      (->> (entities/find-entities {:entity-db entity-db :components components :schema schema}
                                   (filter #(some (set user-ids) #{(:db/id %)})))
           (sort (partial user-model/user-sort-lastname (:db/id current-user)))))))

(rf/reg-sub ::assignee
  :<- [::ws-subs/workspace]
  :-> :workspace/assignee)

(rf/reg-sub ::assignee-fullname
  :<- [::assignee]
  :-> user-model/full-name)

(defn assigned-to [workspace tr]
  (let [assigned-to           (<sub [::assignee])
        assigned-to-full-name (<sub [::assignee-fullname])
        session-user          (<sub [:session/user])
        stakeholder-users     (<sub [::auth-users-sorted])
        target                (case (:domain/state workspace)
                                :workspace.state/application (workspace-model/workspace-application workspace)
                                :workspace.state/execution (workspace-model/workspace-execution workspace)
                                :workspace.state/pre-consultation (workspace-model/workspace-pre-consultation workspace)
                                (workspace-model/workspace-application workspace))
        authority?            (<sub [:app.front.process/signal-permitted? (:db/id target) [:process.signal/set-assignee]])
        items                 (cons {:id "unassigned" :label (tr [:unassigned])}
                                    (for [user stakeholder-users]
                                      {:label (str (user-model/full-name user)
                                                   (when (= (:db/id user) (:db/id session-user))
                                                     (str " " (tr [:assign-to-me]))))
                                       :id    (:db/id user)}))]
    (when (or authority?
              assigned-to)
      [:div.flex.flex-row.space-x-2.mt-3.md:mt-0.lg:w-1-3.xxl:w-1-4.items-center.md:justify-end
       [dg/header-label (tr [:workspace/assigned-to])]
       (if authority?
         [:div.mb-2.flex-grow
          (cc/combo-box {:id          "workspace-assignee"
                         :placeholder (if (str/blank? assigned-to-full-name)
                                        (tr [:unassigned])
                                        assigned-to-full-name)
                         :aria-label  (tr [:workspace/assigned-to])
                         :on-change   (fn [^js e]
                                        (let [selected-id (-> e .-selectedItem (js->clj :keywordize-keys true) :id)]
                                          ;; prevent from firing when value is not changed
                                          (when (and (not (and (nil? assigned-to)
                                                               (= "unassigned" selected-id)))
                                                     (not= (:db/id assigned-to) selected-id))
                                            (>evt [:app.front.process/signal
                                                   target
                                                   (if (or (nil? selected-id)
                                                           (= "unassigned" selected-id))
                                                     [:process.signal/remove-assignee]
                                                     [:process.signal/set-assignee {:assignee (-> selected-id js/parseInt)}])
                                                   {:notify {:success :workspace/successfully-assigned}}]))))
                         :items       items})]
         [:div.mb-2 assigned-to-full-name])])))

(rf/reg-event-fx ::change-sensitivity-level-of-workspace
  (fn [_ [_ application value]]
    {:dispatch [:app.front.process/signal
                (:db/id application)
                [:process.signal/change-sensitivity-level-of-workspace {:value value}]
                {:notify {:success :archiving/sensitivity-level-updated}}]}))

(rf/reg-sub ::secondary-map-markers
  :<- [::property-subs/candidate-point]
  :<- [::workspace-location/manual-coordinates]
  (fn [[candidate-point manual-coordinates] _]
    (remove nil? [candidate-point manual-coordinates])))

(rf/reg-event-fx ::navigate-to-permit
  (fn [{:keys [db]} [_ workspace-id]]
    (js/window.location.replace
      (str (href/href :view/workspace-application {:workspace-id workspace-id}) "#section--application-permits"))
    (when (and (str/index-of (js/window.location.toString) "/application")
               (-> js/document (.getElementById "section--application-permits") not))
      (js/window.location.reload)) ; force reload - in case user is on an application page without permits section
    {:db (assoc-in db [::section/state "section--application-permits" :collapsed?] false)}))

(defn address-with-municipality-name [lang tr workspace]
  (let [full-address (if (<sub [::ff/enabled? :feature-flag.id/property-db-units])
                       (workspace-model/full-address-with-units workspace lang tr)
                       (workspace-model/full-address workspace))]
    (->> [(cond
            (-> workspace :workspace/permit-type (= :permit-type/LS))
            (-> workspace :licence/_workspaces seq first :licence/address)
            full-address
            full-address
            (-> workspace workspace-model/single-property :property/type (= :property.type/road))
            (-> workspace workspace-model/single-property :property/description)
            (-> workspace :entity/location)
            (futil/location-coordinates workspace)
            :else
            (tr [:address/address-missing]))
          (<sub [::municipality-name])
          (<sub [::upper-tier-municipality-name])]
         (remove nil?)
         (str/join ", "))))

(defn- select-feature [id]
  (>evt [::workspace-location/select-feature id]))

(defn map-wrapper [{:keys [workspace]}]
  (r/with-let [property-types (->> (-> [:property.type/property]
                                       (conj (-> workspace :workspace/primary-property :property/type)))
                                   ;; :property/type is not mandatory in schema, nils may happen
                                   (remove nil?)
                                   distinct)]
    (let [property-location  (-> workspace :workspace/primary-property :entity/location)
          workspace-location (:entity/location workspace)
          location           (or workspace-location
                                 property-location
                                 ;; center location not set for all, can be fixed with municipality group editor
                                 (-> workspace :workspace/municipality :municipality/center-location))
          show-row-layers?   (and (ptc-model/permit-types-with-row-layers (:workspace/permit-type workspace))
                                  (ff/enabled? :feature-flag.id/public-works-location-enhancements))
          layers             (<sub [::municipality/ws-municipal-layers show-row-layers?])
          candidate-point    (<sub [::property-subs/candidate-point])
          primary-point      (when location
                               [(-> location :location.center/x)
                                (-> location :location.center/y)])
          map-center         (or candidate-point
                                 primary-point)
          properties         (<sub [::property-subs/additional-property-geometries])
          workspace-geometry (or (<sub [::workspace-location/modified-workspace-geometry])
                                 (:location/shape workspace-location))
          property-widget?   (<sub [::property-subs/property-widget-visible?])
          edit-ws-location?  (<sub [::workspace-location/open?])
          change-loc-center? (<sub [::workspace-location/change-location-center?])]
      (when (and layers map-center)
        [workspace-map/workspace-map
         (merge-with merge
                     {:center              map-center
                      :layers              layers
                      :extended?           true
                      :primaryMapMarkers   [primary-point]
                      :secondaryMapMarkers (<sub [::secondary-map-markers])
                      :setLayerIdOrder     #(>evt [::create-v2/set-layer-id-order %])
                      :propertyGeometries  {:primaryPropertyGeometry      (property-model/geojson-feature
                                                                            (:location/shape property-location))
                                            :additionalPropertyGeometries (property-model/geojson-feature-collection
                                                                            (->> properties
                                                                                 (filter #(= (:type %) "Polygon"))
                                                                                 (map property-model/geojson-feature)))
                                            :roadSegmentGeometries        (property-model/geojson-feature-collection
                                                                            (->> properties
                                                                                 (filter #(not= (:type %) "Polygon"))
                                                                                 (map property-model/geojson-feature)))}
                      :workspaceGeometries (<sub [::workspace-geometry-as-features workspace-geometry])}
                     (if edit-ws-location?
                       {:onDrawingComplete (fn [drawing]
                                             (let [drawing (js->clj drawing :keywordize-keys true)]
                                               (>evt [::workspace-location/edit-workspace-geometry
                                                      :workspace-location/add
                                                      workspace-geometry
                                                      drawing])))
                        :onModifyComplete  (fn [drawing]
                                             (let [drawing (js->clj drawing :keywordize-keys true)]
                                               (>evt [::workspace-location/edit-workspace-geometry
                                                      :workspace-location/edit
                                                      workspace-geometry
                                                      drawing])))
                        ;; Use named function to prevent unnecessary re-renders
                        :onSelectFeature   select-feature
                        :hiddenTools       []
                        :hiddenDrawTools   []}
                       ;; Needed to ensure that no draw tool is left active after editing ws location
                       {:drawTool nil})
                     {:events [{:eventType     "singleclick"
                                :eventFunction (fn [^js e]
                                                 (cond
                                                   property-widget?
                                                   (>evt [::property-subs/on-map-click
                                                          property-types
                                                          (-> workspace
                                                              :domain/authority-group
                                                              :entity/parent
                                                              :group/id)
                                                          (-> workspace
                                                              :workspace/municipality
                                                              :municipality/number)
                                                          (.-coordinate e)])

                                                   (and edit-ws-location? change-loc-center?)
                                                   (do
                                                     (>evt [::workspace-location/set-manual-location-coordinates (.-coordinate e)])
                                                     (>evt [::workspace-location/set-change-location-center]))))}]})]))))

(defn approval-authority [{:keys [tr workspace]}]
  (when (-> workspace :domain/authority-group :group/authority-delegates seq)
    (let [appr-group (or (:workspace/approval-authority workspace)
                         (:domain/authority-group workspace))]
      [ws-info
       (tr [:workspace/approval-authority])
       [:div (:group/name appr-group)]])))

(defn ws-tag [workspace key]
  (when (-> workspace key)
    (let [tr (<sub [:tr])]
      [ui/tag {:color      :blue
               :type       :round
               :class-name "mb-4"}
       (str/upper-case (tr [key]))])))

(defn permit-type-header [tr {:workspace/keys [permit-type] :as workspace}]
  (let [user            (<sub [:session/user])
        authority-group (<sub [::ws-subs/authority-group])
        authority?      (authority/authority-in-group? user authority-group)
        show-switcher?  (and (ff/enabled? :feature-flag.id/application-wizard)
                             authority?
                             (application-wizard/wizard-allowed-for-workspace? workspace))]
    (when (or permit-type show-switcher?)
      (let [icon             (ui/permit-type-icon permit-type)
            permit-type-name (<sub [::ws-subs/permit-type-name])]
        [:div.flex.flex-col.md:flex-row.md:content-center.md:items-center.md:justify-between.gap-4
         (when permit-type
           [:div.flex.flex-row.content-center.items-center.min-w-0.flex-1
            (when icon [:div.border-2.border-solid.rounded-full.mr-2.p-1.flex-shrink-0
                        [:> icon {:class-name "block"}]])
            [:h4.break-words permit-type-name]])
         (when show-switcher?
           [application-wizard/page-switcher-view {:tr           tr
                                                   :workspace-id (:workspace/id workspace)
                                                   :current-view :workspace}])]))))

(defn address-header [lang tr workspace loading?]
  (let [address-in-editor  (<sub [::address-in-editor])
        property           (workspace-model/single-property workspace)
        fsm-target         (<sub [::app-phase-subs/current-child])
        show?              (<sub [::show-address-header?])
        last-update        (-> workspace :workspace/primary-property :property/last-updated-from-gis)
        units-not-enabled? (not (ff/enabled? :feature-flag.id/property-db-units))]
    (if loading?
      (cc/skeleton-text {:heading true})
      (when show? ;; For licensing, category is the main header if no address.
        [:div.flex.flex-col.mb-4
         [:div.flex.flex-row.items-end.my-2
          (if (and address-in-editor
                   units-not-enabled?)
            [address-editor tr workspace (:db/id fsm-target)]
            [:div.flex.items-center
             [:h2 {:data-cy "address-header"} (address-with-municipality-name lang tr workspace)]
             (when (and (<sub [:app.front.process/signal-permitted? fsm-target [:process.signal/edit-address]])
                        units-not-enabled?)
               [ui/button
                {:kind             :ghost
                 :icon             i/pen
                 :icon-position    :right
                 :icon-description (tr [:workspace/edit-address])
                 :class-name       "ml-2 only-icon-button"
                 :on-click         #(>evt [::set-address-in-editor (-> workspace
                                                                       :workspace/structural-address
                                                                       (select-keys address-model/address-keys))])}
                ""])
             (when (and (<sub [::process/app-signal-permitted? [:process.signal/change-primary-property]])
                        (nil? property))
               [ui/button
                {:kind       :primary
                 :size       :small
                 :class-name "ml-2"
                 :on-click   #(>evt [::set-change-property-visible])}
                (tr [:workspace/update-location])])
             [:div.ml-2.flex.content-center
              (when (and (-> workspace :workspace/structural-address :address/address-source (= :address-source/user))
                         units-not-enabled?)
                [ui/tag {:color      :blue
                         :type       :round
                         :class-name "ml-2"}
                 (str/upper-case (tr [:address-source/user]))])]])]
         (when last-update
           [:div.flex
            (str (tr [:workspace/last-location-update]) ": " ((<sub [::date-util/date-time-fn]) last-update))])]))))

(defn- property-attribute-pinned? [authority-group {:property-attribute/keys [template]}]
  (-> template
      :property-attribute-template/pinned-in-groups
      set
      (contains? authority-group)))

(defn- has-hideable-data? [{:keys           [:domain/authority-group]
                            :workspace/keys [permit-type]}
                           property-attributes]
  (or (not (contains? ptc-model/permit-types-without-mandatory-location permit-type))
      (some #(not (property-attribute-pinned? authority-group %))
            property-attributes)))

(defn action-row [tr workspace application full-ws-info-visible?]
  (let [verdicts         (<sub [::entities/entities {:entity/type   :entity.type/verdict
                                                     :entity/parent (:db/id application)}])
        issued-permit    (p/find-first verdicts #(and (:verdict/file-object-key %)
                                                      (-> % :domain/state verdict-model/post-issue-states)))
        primary-property (workspace-model/single-property workspace)
        property-attrs   (<sub [::ws-subs/property-attributes-with-templates])]
    [:div
     [:div.flex.flex-col.md:flex-row.justify-between
      [:div.flex.flex-col
       [:div.flex.flex-row.flex-wrap.space-x-2
        (when (workspace-model/has-location workspace)
          [header-common/toggle-map-or-property-data-button (util/mmap {:map-view-id (:db/id workspace)
                                                                        :ws-view?    true}
                                                                       tr)])
        (when (and (some? primary-property)
                   (ff/enabled? :feature-flag.id/property-db-units))
          (let [label (tr [:workspace/go-to-property])
                href  (property-util/property-link primary-property {:workspace-ref (:workspace/id workspace)})]
            [ui/button
             {:kind             :tertiary
              :size             :small
              :icon             i/arrow-right
              :class-name       ""
              :icon-position    :right
              :icon-description label
              :href             href}
             label]))
        (when (has-hideable-data? workspace property-attrs)
          (let [label (tr [(if full-ws-info-visible? :workspace/hide-full-data :workspace/show-full-data)])]
            [ui/button
             {:kind             :tertiary
              :size             :small
              :icon             (if full-ws-info-visible? i/remove i/documents)
              :class-name       ""
              :icon-position    :right
              :icon-description label
              :on-click         #(>evt [::toggle-full-workspace-info-visibility])}
             label]))
        [permit-download/download-button (util/mmap {:verdict issued-permit} tr)]]]
      [assigned-to workspace tr]]

     [ui-sep/horizontal]]))

(defn- property-attr [{:keys [tr property attr]}]
  (when-let [integration-id (attr property)]
    [ws-info
     (tr [attr])
     [:p integration-id]]))

(defn- location-attribute [{:keys [tr location attr]}]
  (when-let [value (attr location)]
    [ws-info
     (tr [attr])
     [:p value]
     true]))

(defn- editable-case-id [tr workspace fsm-target application]
  [editable-attr (merge
                   {:title            (tr [:licence/temporary-id])
                    :data-cy          "municipal-case-id"
                    :attr             :workspace/municipal-case-id
                    :workspace        workspace
                    :target-id        (:db/id fsm-target)
                    :change-signal-fn (fn [value]
                                        [:process.signal/change-case-id (util/mmap value)])
                    :always-visible?  true
                    :tr               tr}
                   (when (get workspace :workspace/municipal-case-id)
                     {:confirm-content (tr [:workspace/municipal-case-id-confirm])})
                   (when (and (not (-> workspace :workspace/legacy-permit?))
                              (<sub [::permit-exists? application]))
                     {:text-container :a.bx--link.cursor-pointer
                      :opts           {:on-click #(>evt [::navigate-to-permit (:workspace/id workspace)])}}))])

(defn- licence-link [{:keys [fsm-target application workspace tr]}]
  (if (-> workspace :licence/_workspaces seq)
    [ws-info (tr [:licence/id])
     (for-frag [licence (->> workspace :licence/_workspaces)]
       (cc/link {:href (href/href :view/licence {:group-id   (-> licence :domain/authority-group :group/id)
                                                 :licence-id (:licence/id licence)})}
                (:licence/id licence)))
     true]
    (if (<sub [::process/signal-permitted? fsm-target [:process.signal/change-case-id]])
      (editable-case-id tr workspace fsm-target application)
      [ws-info (tr [:licence/temporary-id]) (:workspace/municipal-case-id workspace) true])))

(defn- new-licence-number [{tr :tr fsm-target :fsm-target {:workspace/keys [application municipal-case-id] :as workspace} :workspace}]
  (when (and (licence-model/renewal-workspace? workspace)
             (licence-model/new-number-on-renewal? workspace)
             (not (du/in-state? :state.application/license-issued
                                (workspace-model/workspace-application workspace)))
             (->> workspace :licence/_workspaces seq)
             (->> workspace
                  :licence/_workspaces
                  (not-any? #(-> % :licence/id (= municipal-case-id)))))
    (if (<sub [::process/signal-permitted? fsm-target [:process.signal/change-case-id]])
      (editable-case-id tr workspace fsm-target application)
      [ws-info (tr [:licence/provisional-new-id]) municipal-case-id true])))

(defn- contractor-registration-link [{:keys [workspace tr]}]
  (let [registration-number (:workspace/municipal-case-id workspace)]
    [ws-info (tr [:workspace/municipal-case-id])
     (if-some [registration (-> workspace :contractor-registration/_workspaces first)]
       (cc/link {:href (href/href :view/contractor-registration
                                  {:group-id (-> registration :domain/authority-group :group/id)
                                   :cr-id    (:contractor-registration/id registration)})}
                registration-number)
       registration-number)
     true]))

(defn- property-attributes [tr {:keys [:domain/authority-group]}]
  (let [lang        (<sub [:language])
        format-date (<sub [::date-util/date-fn])
        attributes  (<sub [::ws-subs/property-attributes-with-templates])]
    (for-frag [{:property-attribute/keys [template] :as attr} attributes]
      [ws-info
       (property-model/attribute-template-name template lang)
       [:p (property-model/attribute-value attr lang tr format-date)]
       (property-attribute-pinned? authority-group attr)
       (:property-attribute-template/critical? template)])))

(defn- property-id [tr workspace fsm-target {:property/keys [id type] :as property}]
  (when (and id
             (not= type :property.type/road))
    [editable-property-attr {:title            (tr [:property/id])
                             :attr             :property/id
                             :link             (property-util/property-link property {:workspace-ref (:workspace/id workspace)})
                             :property         property
                             :fsm-target       fsm-target
                             :change-signal-fn (fn [value]
                                                 [:process.signal/edit-property-attribute
                                                  {:property-id (:db/id property)
                                                   :property/id value}])
                             :always-visible?  true
                             :read-only?       (ff/enabled? :feature-flag.id/property-db-units)
                             :tr               tr}]))

(defn- municipal-case-id [tr workspace application fsm-target]
  (let [permit-exists? (<sub [::permit-exists? application])]
    [editable-attr (merge
                     {:title            (tr [:workspace/municipal-case-id])
                      :data-cy          "municipal-case-id"
                      :attr             :workspace/municipal-case-id
                      :workspace        workspace
                      :target-id        (:db/id fsm-target)
                      :change-signal-fn (fn [value]
                                          [:process.signal/change-case-id (util/mmap value)])
                      :always-visible?  true
                      :tr               tr}
                     (when (get workspace :workspace/municipal-case-id)
                       {:confirm-content (tr [:workspace/municipal-case-id-confirm])})
                     (when (and (not (-> workspace :workspace/legacy-permit?))
                                permit-exists?)
                       {:text-container :a.bx--link.cursor-pointer
                        :opts           {:on-click   #(>evt [::navigate-to-permit (:workspace/id workspace)])
                                         :aria-label (tr [:verdict/view-permit])}}))]))

(defn- property-description [tr property]
  (when-let [property-description (when (-> property :property/from-st)
                                    (tr [:property/from-to]
                                        [(:property/from-st property)
                                         (:property/to-st property)]))]
    [ws-info
     (tr [:property/description])
     [:p property-description]]))

(defn- legal-description [tr fsm-target {:property/keys [type] :as property} loading?]
  (let [legal-required?        (<sub [::ws-subs/property-attr-required? :property/legal])
        change-legal-signal-fn (fn [value]
                                 [:process.signal/edit-property-attribute
                                  {:property-id    (:db/id property)
                                   :property/legal value}])]
    (when (and property
               (not= type :property.type/road)
               (not loading?)
               (or legal-required?
                   (some? (:property/legal property))
                   (<sub [::process/signal-permitted? fsm-target (change-legal-signal-fn nil)])))
      [editable-property-attr {:title            (tr [:property/legal])
                               :attr             :property/legal
                               :property         property
                               :fsm-target       fsm-target
                               :change-signal-fn change-legal-signal-fn
                               :missing-warning  (when legal-required?
                                                   (tr [:application.property/legal-missing]))
                               :read-only?       (ff/enabled? :feature-flag.id/property-db-units)
                               :tr               tr}])))

(defn- external-id [tr {:workspace/keys [external-id] :as workspace} fsm-target authority?]
  (let [show-sync? (and authority?
                        (or external-id
                            (<sub [::process/execution-signal-permitted?
                                   [:process.signal/change-external-id]])))]
    (when show-sync?
      [editable-attr {:title            (str (<sub [::ws-subs/backend-system-name]) " ID")
                      :data-cy          "external-id"
                      :attr             :workspace/external-id
                      :workspace        workspace
                      :target-id        (:db/id fsm-target)
                      :change-signal-fn (fn [value]
                                          [:process.signal/change-external-id {:value (when value (str/trim value))}])
                      :tr               tr}])))

(defn- ecm-integration-id [{:entity/keys [ecm-integration-id]} authority?]
  (when (and authority? ecm-integration-id)
    (let [loading? (<sub [::ws-subs/loading-config?])]
      [ws-info
       (if loading?
         (cc/skeleton-text)
         (str (<sub [::ws-subs/ecm-system-name]) " ID"))
       (if loading?
         (cc/skeleton-text)
         [:p (if-let [url (<sub [::ws-subs/ecm-folder-link])]
               (cc/link {:href url :target "_blank"} ecm-integration-id)
               ecm-integration-id)])])))

(defn- archiving-sensitivity [tr {:workspace/keys [sensitivity-level] :as workspace} application]
  (when (<sub [::ws-subs/archiving])
    [ws-info
     (tr [:workspace/sensitivity-level])
     (if (<sub [:app.front.process/app-signal-permitted?
                [:process.signal/change-sensitivity-level-of-workspace
                 {:value sensitivity-level}]])
       [ui-select/select {:id           (str "sensitivity-level-" (:db/id workspace))
                          :values       workspace-model/workspace-sensitivity-values
                          :val->str     #(when %
                                           (tr [%]))
                          :allow-empty? false
                          :on-change    #(>evt [::change-sensitivity-level-of-workspace application %])
                          :value        sensitivity-level}]
       [:p (tr [sensitivity-level])])]))


(defmulti workspace-data (fn [_tr workspace _application _property _loading?]
                           (:workspace/permit-type workspace)))

(defmethod workspace-data :default [tr workspace application property loading?]
  (let [authority? (-> workspace :granted-permissions :permission.application/review)
        fsm-target (<sub [::app-phase-subs/current-child])]
    [dg/data-grid
     [property-id tr workspace fsm-target property]
     [municipal-case-id tr workspace application fsm-target]
     [property-attr (util/mmap {:attr :property/secondary-id} property tr)]
     [property-attr (util/mmap {:attr :property/integration-id} property tr)]
     [property-attr (util/mmap {:attr :property/type-code} property tr)]
     [property-description tr property]
     [legal-description tr fsm-target property loading?]
     [property-attr (util/mmap {:attr :property/zoning} tr property)]
     [property-attr (util/mmap {:attr :property/ward} tr property)]
     [created-at (util/mmap workspace tr)]
     [submitted-at (util/mmap fsm-target tr)]
     [pre-con-finished-at (util/mmap fsm-target tr)]
     [pre-con-expires-at (util/mmap fsm-target tr)]
     [completed-at (util/mmap workspace application tr)]
     [decision-made-at (util/mmap fsm-target tr)]
     [work-started-at (util/mmap fsm-target tr)]
     [work-finished-at (util/mmap fsm-target tr)]
     [approval-authority (util/mmap workspace tr)]
     [integration-sync-times (util/mmap {:attr :workspace/integration-sync-times}
                                        workspace tr authority?)]
     [external-id tr workspace fsm-target authority?]
     [integration-sync-times (util/mmap {:label (tr [:workspace/ecm-sync-times]
                                                    [(<sub [::ws-subs/ecm-system-name])])
                                         :attr  :workspace/ecm-sync-times}
                                        workspace tr authority?)]
     [ecm-integration-id workspace authority?]
     [archiving-sensitivity tr workspace application]
     [property-attributes tr workspace]]))

(defn- licence-header-data [{:keys [tr workspace property application]}]
  (let [fsm-target (<sub [::app-phase-subs/current-child])]
    [dg/data-grid
     [property-id tr workspace fsm-target property]
     [licence-link (util/mmap fsm-target application workspace tr)]
     [new-licence-number (util/mmap tr fsm-target workspace)]
     [submitted-at (util/mmap {:always-visible? true} fsm-target tr)]
     [property-attributes tr workspace]]))

(defmethod workspace-data :permit-type/L [tr workspace application property _loading?]
  [licence-header-data (util/mmap tr workspace property application)])

(defmethod workspace-data :permit-type/LS [tr workspace application property _loading?]
  [licence-header-data (util/mmap tr workspace property application)])

(defmethod workspace-data :permit-type/CR [tr workspace _application _property _loading?]
  (let [fsm-target (<sub [::app-phase-subs/current-child])]
    [dg/data-grid
     [contractor-registration-link (util/mmap workspace tr)]
     [submitted-at (util/mmap {:always-visible? true} fsm-target tr)]]))

(defn id-legal-editor [tr property-id target-id type-str editing? value value-in-editor set-fn cancel-fn save-signal]
  [:div.flex.flex-row.w-full
   [ui/text-input {:id          (str "property-" property-id "-" type-str "-input")
                   :placeholder value
                   :disabled    (not editing?)
                   :value       (or value-in-editor value)
                   :on-change   set-fn}]
   [ui-ib/icon-button
    {:icon        i/remove
     :description (tr [:cancel])
     :on-click    cancel-fn}]
   [ui-ib/icon-button
    {:icon        i/check
     :description (tr [:save])
     :disabled?   (or (str/blank? value-in-editor)
                      (= value value-in-editor))
     :on-click    #(>evt [::save-modified-id-or-legal target-id save-signal])}]])

(defn- property-editable-attributes [lang tr target-id workspace property]
  (let [property-id          (:property/id property)
        address              (workspace-model/full-address-with-units workspace lang tr)
        legal                (:property/legal property)
        editing-id?          (<sub [::editing-property-id?])
        editing-legal?       (<sub [::editing-property-legal?])
        workspace-address-id (-> workspace :workspace/structural-address :db/id)
        address-in-editor    (<sub [::address-in-editor])
        id-in-editor         (<sub [::id-in-property-editor])
        legal-in-editor      (<sub [::legal-in-property-editor])
        id-signal            [:process.signal/edit-property-attribute
                              {:property-id (:db/id property)
                               :property/id id-in-editor}]
        legal-signal         [:process.signal/edit-property-attribute
                              {:property-id    (:db/id property)
                               :property/legal legal-in-editor}]
        property?            (some? property)]
    [:div.flex.flex-col
     ;; Address needs to be editable regardless of if there is a property on the workspace or not. Id and legal only if there is a property.
     [:span (tr [:workspace/address])]
     [:div.flex.flex-row.mb-3.gap-2.items-end
      (if address-in-editor
        [address-editor tr workspace target-id]
        [:div.flex.flex-row.w-full.justify-between
         [:strong.pt-2 address]
         (when (<sub [::process/signal-permitted?
                      target-id
                      [:process.signal/edit-address]])
           [ui/button
            {:kind     :ghost
             :icon     i/pen
             :size     :field
             :on-click (if address-in-editor
                         #(>evt [::save-modified-address workspace-address-id target-id])
                         #(>evt [::set-address-in-editor (-> workspace
                                                             :workspace/structural-address
                                                             (select-keys address-model/address-keys))]))}
            (tr [:edit])])])]

     (when property?
       [:<>
        [:span (tr [:property/id])]
        [:div.flex.flex-row.mb-3.gap-2.items-end
         (if editing-id?
           [id-legal-editor tr property-id target-id "id" editing-id? property-id id-in-editor
            #(>evt [::set-id-in-property-editor (futil/tval %)]) #(>evt [::set-property-id-edit false])
            id-signal]
           [:div.flex.flex-row.w-full.justify-between
            [:strong.pt-2 property-id]
            (when (<sub [::process/signal-permitted?
                         target-id
                         id-signal])
              [ui/button
               {:kind     :ghost
                :icon     i/pen
                :size     :field
                :on-click #(>evt [::set-property-id-edit true])}
               (tr [:edit])])])]])

     (when property?
       [:<>
        [:span (tr [:property/legal])]
        [:div.flex.flex-row.mb-3.gap-2.items-end
         (if editing-legal?
           [id-legal-editor tr property-id target-id "legal" editing-legal? legal legal-in-editor
            #(>evt [::set-legal-in-property-editor (futil/tval %)]) #(>evt [::set-property-legal-edit false])
            legal-signal]
           [:div.flex.flex-row.w-full.justify-between
            [:strong.pt-2 legal]
            (when (<sub [::process/signal-permitted?
                         target-id
                         legal-signal])
              [ui/button
               {:kind     :ghost
                :icon     i/pen
                :size     :field
                :on-click #(>evt [::set-property-legal-edit true])}
               (tr [:edit])])])]])]))

(defn- property-edit-functions [tr target-id workspace]
  (let [on-cancel                          #(>evt [::cancel-location-editing])
        change-primary-property-permitted? (<sub [::process/signal-permitted?
                                                  target-id
                                                  [:process.signal/change-primary-property]])
        add-additional-property-permitted? (<sub [::process/signal-permitted?
                                                  target-id
                                                  [:process.signal/add-additional-property]])]
    [:div.flex.flex-col
     [:div.flex.flex-row
      (when change-primary-property-permitted?
        [:div.flex.mr-2
         [ui/button
          {:kind     :tertiary
           :size     :field
           :on-click (if (<sub [::property-subs/change-property-visible?])
                       on-cancel
                       #(>evt [::set-change-property-visible]))}
          (tr [:process.signal/change-primary-property])]])
      (when add-additional-property-permitted?
        [:div.flex
         [ui/button
          {:kind     :tertiary
           :size     :field
           :on-click (if (<sub [::property-subs/add-visible?])
                       on-cancel
                       #(>evt [::set-add-properties-visible]))}
          (tr [:process.signal/add-additional-property])]])]
     [additional-properties/add-widget (util/mmap target-id workspace tr on-cancel)]
     [additional-properties/change-property-widget (util/mmap target-id workspace tr on-cancel)]]))

(defn property-data-view [lang tr workspace property]
  (let [target-id  (-> (<sub [::ws-subs/workspace-target])
                       :db/id)
        properties (->> (:workspace/properties workspace)
                        (sort-by (juxt (workspace-model/is-secondary-property-fn workspace)
                                       :property/id)))]
    [section/section
     "property-data-view"
     {:tr               tr
      :always-expanded? true}
     (tr [:workspace/location-and-property])
     [:div.flex.flex-row.mb-4
      [:div.w-1-2.map-boundary.mr-4.bg-gray-400.flex.items-center.justify-center.map-extended.border.border-ui-dark-gray.border-solid
       [map-wrapper (util/mmap workspace target-id)]]

      [:div.w-1-2
       [units-editor/read-only-info-columns-list {:tr tr :workspace workspace}]
       [property-edit-functions tr target-id workspace]
       [ui-sep/horizontal-line]
       [property-editable-attributes lang tr target-id workspace property]]]
     [ui-sep/horizontal-line]
     [units-editor/editor-list {:tr          tr
                                :editable?   true
                                :target-id   target-id
                                :properties  properties
                                :units       (:workspace/property-units workspace)
                                :designators (<sub [::ws-subs/property-unit-designators])}]]))

(defn header [{:keys [lang tr current-child]}]
  (let [workspace             (<sub [::ws-subs/workspace])
        application           (<sub [::ws-subs/application])
        loading?              (<sub [::ws-subs/loading?])
        property              (workspace-model/single-property workspace)
        attributes            (-> property :property/legacy-attributes)
        map-visible?          (<sub [::map-visible? (:db/id workspace)])
        full-ws-info-visible? (<sub [::full-workspace-info-visible?])
        target-id             (:db/id current-child)
        on-cancel             #(>evt [::cancel-location-editing])
        units-enabled?        (ff/enabled? :feature-flag.id/property-db-units)]
    [:div.mb-8
     [permit-type-header tr workspace]

     [address-header lang tr workspace loading?]

     [work-select/category-work-type-target-widget (util/mmap tr workspace)]

     [action-row tr workspace application full-ws-info-visible?]

     (if map-visible?
       [:div.flex.flex-col
        (if units-enabled?
          [property-data-view lang tr workspace property]
          [:div.map-boundary.mb-4.md:mb-0.mr-6.w-full.bg-gray-400.flex.flex-shrink-0.items-center.justify-center.map-extended
           [map-wrapper (util/mmap workspace target-id)]])
        (when-not units-enabled?
          [:<>
           [additional-properties/add-widget (util/mmap target-id workspace tr on-cancel)]
           [additional-properties/change-property-widget (util/mmap target-id workspace tr on-cancel)]])
        [workspace-location/edit-workspace-geometry-widget (util/mmap target-id workspace tr on-cancel)]]

       [:div
        [ws-tag workspace :workspace/omit-from-search?]
        [ws-tag workspace :workspace/legacy-permit?]

        [:div.flex.mb-2.flex-col.md:flex-row
         (when (->> workspace
                    :entity/_parent
                    (mapcat :entity/_parent)
                    (filter party-model/is-party?)
                    seq)
           ;; only show messages for workspaces that have parties
           [application-messaging-row (util/mmap tr loading? workspace)])
         [application-email-notifications (util/mmap tr target-id workspace)]]
        [:div.flex.flex-col
         (when (and (not loading?) property (not (property-model/gis-verified? property)))
           [:div.mb-2
            [ui/tag {:color      :blue
                     :type       :round
                     :class-name "ml-0"}
             (str/upper-case (tr [:property/data-source-user]))]])
         [:div.flex.flex-row.mb-1 [property-attribute/attribute-tags attributes]]
         [workspace-data tr workspace application property loading?]]
        (when-let [{:keys [latitude longitude]} (-> workspace :entity/location futil/lat-long)]
          (let [location {:location/latitude    latitude
                          :location/longitude   longitude
                          :location/description (get-in workspace [:entity/location :location/description])}]
            [:div.flex.flex-col.mt-2
             [dg/data-grid
              [location-attribute (util/mmap {:attr :location/latitude} location tr)]
              [location-attribute (util/mmap {:attr :location/longitude} location tr)]
              [location-attribute (util/mmap {:attr :location/description} location tr)]]]))])]))
